export const thatsHowLoveGoesLyrics = [
  { text: "So um", start: 11, end: 13.5 },
  { text: "I been thinking", start: 13.5, end: 15.6 },
  { text: "And", start: 15.06, end: 18 },
  { text: "Just hear me out", start: 18, end: 21.9 },
  { text: "Okay", start: 21.9, end: 22.23 },
  { text: "Met cha on a Saturday", start: 22.23, end: 26.4 },
  { text: "I don't really wanna wait around", start: 26.4, end: 31.3 },
  { text: "Around", start: 31.3, end: 35.6 },
  { text: "Can we skip to Sunday", start: 35.6, end: 38.6 },
  { text: "I'm don't really wanna wait around", start: 38.6, end: 44.03 },
  { text: "Mmm around", start: 44.03, end: 46.44 },
  { text: "I need", start: 46.44, end: 48.7 },
  { text: "Your hand in mine", start: 48.7, end: 51.8 },
  { text: "Boy you drive me wild", start: 51.8, end: 54.8 },
  { text: "You drive me wild", start: 54.8, end: 56.5 },
  { text: "Wild", start: 56.5, end: 57.9 },
  { text: "You drive me wild", start: 57.9, end: 60.3 },
  { text: "I've got what you need", start: 60.3, end: 63.5 },
  { text: "Can I come swing by yours tonight", start: 63.5, end: 66.8 },
  { text: "Tonightttt", start: 66.8, end: 68 },
  { text: "Would that be fine", start: 68, end: 70 },
  { text: "Your mine", start: 70, end: 71 },
  { text: "Your mine", start: 71, end: 72.1 },
  { text: "Your mi", start: 72.1, end: 72.5 },
  { text: "I really like the way", start: 72.5, end: 75.3 },
  { text: "The way you say my name", start: 75.3, end: 77.5 },
  { text: "Name", start: 77.5, end: 83.1 },
  { text: "Tell me will you come around", start: 83.1, end: 87.25 },
  { text: "Please don't count me out", start: 87.25, end: 90 },
  { text: "I love it when you count me out", start: 90, end: 92.5 },
  { text: "Don't count me out", start: 92.5, end: 94 },
  { text: "I love it when you count me out, out", start: 94, end: 95.9 },
  { text: "He told me he loved me with my head out the window that's how love goes", start: 95.9, end: 103.5 },
  { text: "Love goes", start: 103.5, end: 105 },
  { text: "Love goes", start: 105, end: 106.5 },
  { text: "Love goes", start: 106.5, end: 107.5 },
  { text: "He told me he loved me with my head out the window", start: 107.5, end: 113 },
  { text: "That how love grows", start: 113, end: 115.87 },
  { text: "Your love grows on me", start: 115.87, end: 120 },
  { text: "Da da da da da da da da da da da da", start: 120, end: 123 },
  { text: "I just wanna let you know", start: 123, end: 127.5 },
  { text: "Da da da da da da da da da da", start: 127.5, end: 120.5 },
  { text: "You're the only one for me", start: 120.5, end: 125 },
  { text: "Da da da da da da da da da da da da", start: 125, end: 135 },
  { text: "Baby I ain't letting go", start: 135, end: 140.5 },
  { text: "Da da da da da da da da da da", start: 140.5, end: 142 }, 
  { text: "I need your company", start: 142, end: 144.5 },
  { text: "Have I told you lately you've been on my mind", start: 144.5, end: 146.7 },
  { text: "Usually I'm nervous keep my feelings on recline", start: 146.7, end: 149.5 },
  { text: "But I'm not playin boo", start: 149.5, end: 150.5 },
  { text: "So what you sayin boo", start: 150.5, end: 152 },
  { text: "How many licks is it gon take for me to get to you", start: 152, end: 155 },
  { text: "Lemme meet yo friends", start: 155, end: 156 },
  { text: "So I can get a co-sign", start: 156, end: 158 },
  { text: "Finally meeting you in", start: 158, end: 159 },
  { text: "Public", start: 159, end: 159.7 },
  { text: "Stead of on my", start: 159.7, end: 160.5 },
  { text: "Timeline", start: 160.5, end: 161.5 },
  { text: "Hmm", start: 161.5, end: 162.4 },
  { text: "Please don't put me in the friend zone", start: 162.4, end: 164.44 },
  { text: "Where you stay at", start: 164.44, end: 165.2 },
  { text: "You got roommates", start: 165.2, end: 166 },
  { text: "Is ya mama home", start: 166, end: 167.4 },
  { text: "Quit the small talk", start: 167.4, end: 169 },
  { text: "Quit", start: 169, end: 169.3 },
  { text: "I'm tryna see somethin", start: 169.3, end: 170.3 },
  { text: "All that tough shit back it up prove you ain't frontin", start: 170.3, end: 173.5 },
  { text: "Please forgive me if I'm coming on too strong", start: 173.5, end: 176 },
  { text: "I just really", start: 176, end: 177.46 },
  { text: "I can't leave you alone", start: 177.46, end: 178.9 },
  { text: "After two weeks you told me you loved me", start: 178.9, end: 183.99 },
  { text: "Well I love having you around", start: 183.99, end: 186.75 },
  { text: "Around", start: 186.75, end: 190.34 },
  { text: "Before you I was lost", start: 190.34, end: 193.87 },
  { text: "I was lonely", start: 193.87, end: 195.96 },
  { text: "Now suddenly I'm", start: 195.96, end: 198.14 },
  { text: "Found", start: 198.14, end: 200 },
  { text: "Found", start: 200, end: 204.7 },
  { text: "Mmm", start: 204.7, end: 207.34 },
  { text: "Awww baby", start: 207.34, end: 209 },
  { text: "I love it when you count me out", start: 209, end: 211 },
  { text: "Baby baby", start: 211, end: 212 },
  { text: "I love it when you count me out", start: 212, end: 215.19 },
  { text: "Baby baby", start: 215.19, end: 216.3 },
  { text: "So um..", start: 216.3, end: 217 },
  { text: "I just can't get too comfortable", start: 217, end: 220 },
  { text: "C- can I call you sometime", start: 220, end: 221.5 },
  { text: "I ain't gon blow you up", start: 222, end: 224.44 },
  { text: "I might", start: 224.44, end: 227.5 },
  { text: "I just can't get too comfortable", start: 227.5, end: 231.25 },
  { text: "Laughs", start: 231.25, end: 232 },
  { text: "Yeahhhh", start: 232, end: 232.8 },
  { text: "Oh I", start: 232.8, end: 233.8 },
  { text: "Hol on", start: 233.8, end: 234.1 },
  { text: "Hol on", start: 234.1, end: 235.96 },
  { text: "This yo real phone number", start: 235.96, end: 239.18 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
